<div>
    <div class="row-layout-track-left-align" *ngIf="modules && modules.length != 0">
        <div
            class="largecard-layout-box__50 transition-insight-card-width"
            *ngFor="let insight of modules"
        >
            <insight-card
                [insightLink]="insight.routerURL"
                [module]="insight.module"
                [insightTitle]="insight.name"
                [insightDescription]="insight.description"
                [imageSource]="insight.cardImgPath"
                [isLocked]="insight.isLocked"
            >
            </insight-card>
        </div>
    </div>

    <app-no-directory-card
        *ngIf="!loading && (!modules || modules.length == 0)"
    ></app-no-directory-card>
</div>
